import { initializeFirebase } from '@bookstore/shared/browser';
import React from 'react';
import ReactDOM from 'react-dom/client';

import App from './App';
import './styles/index.css';
import { config, validateEnv } from './config/env';

// Validate environment variables
validateEnv();

// Initialize Firebase
initializeFirebase(config.firebase);

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
